export const COURSES = [
    { id: "cna", name: "Certified Nursing Assistant (CNA)", durationLabel: "4 weeks", idphRequired: true, phase1Lifecycle: "full" },
    { id: "ekg", name: "EKG Technician Program", durationLabel: "4 weeks", idphRequired: false, phase1Lifecycle: "inquiry-only" },
    { id: "nclex-rn", name: "NCLEX-RN Review Program", durationLabel: "Flexible", idphRequired: false, phase1Lifecycle: "inquiry-only" },
    { id: "nclex-pn", name: "NCLEX-PN Review Program", durationLabel: "Flexible", idphRequired: false, phase1Lifecycle: "inquiry-only" },
    { id: "aha", name: "AHA Courses: CPR, ACLS & PALS", durationLabel: "1-2 days", idphRequired: false, phase1Lifecycle: "inquiry-only" },
    { id: "advanced-cert", name: "Advanced Certification: CCRN, PCCN, CMSRN", durationLabel: "8 weeks", idphRequired: false, phase1Lifecycle: "inquiry-only" },
    { id: "phlebotomy", name: "Certified Phlebotomy Technician", durationLabel: "3 weeks", idphRequired: false, phase1Lifecycle: "inquiry-only" },
];
export const COURSE_IDS = COURSES.map((c) => c.id);
export const courseById = (id) => COURSES.find((c) => c.id === id);
/**
 * True only for courses with the full student lifecycle (portal, quizzes,
 * homework, course materials) - today that's CNA alone. The single gate the
 * quiz engine, scheduler, portal nav, and admin student page all check so the
 * CNA-only rule lives in one place.
 */
export const hasFullLifecycle = (id) => courseById(id)?.phase1Lifecycle === "full";
//# sourceMappingURL=courses.js.map